module.exports = __webpack_public_path__ + "static/img/map1.fd20182.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about/map1.png
// module id = gvVT
// module chunks = 0